export const bestSellingModels = [
  "strada",
  "polo",
  "onix",
  "hb20",
  "mobi",
  "t-cross",
  "argo",
  "tracker",
  "creta",
  "kwid",
  "compass",
  "nivus",
  "kicks",
  "cronos",
  "hr-v",
  "renegade",
  "saveiro",
  "hilux",
  "pulse",
  "corolla",
  "fastback",
  "montana",
  "208",
  "virtus",
  "c3",
  "duster",
  "frontier",
  "t4",
];
